import AlertService from "../../services/alert";

export const setError = (errorMessage: string, setShow: Function, setAlertServiceValues: Function) => {
	const alertService = AlertService.createErrorMessage(errorMessage)
	setShow(true)
	setAlertServiceValues(alertService.getInitialValues())
	setTimeout(() => {
		setShow(false)
	}, 5000)
}